import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import PenalInterestRemarksPageUI from './PenalInterestRemarksPageUI.js'

class PenalInterestRemarksPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      penalInterestRemarksList: null,
      objectCode: null,
      objectId: null,
      createMode: false,
      updateRemarksMode: false
    }
  }

  render() {
    return (
      <PenalInterestRemarksPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        objectCode={this.state.objectCode}
        objectId={this.state.objectId}
        createMode={this.state.createMode}
        updateRemarksMode={this.state.updateRemarksMode}
        onCancelRemarksClick={() => { this.setState({ createMode: false, updateRemarksMode: false }) }}
        onCreateRemarksClick={this.onCreateRemarksClick}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        selectedDate={this.state.selectedDate}
        selectedRemarks={this.state.selectedRemarks}
        selectedRemarksId={this.state.selectedRemarksId}
        penalInterestRemarksList={this.state.penalInterestRemarksList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getPenalInterestRemarks(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getPenalInterestRemarks(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/penal_interest/remarks`,
      cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'penal_interest'),
      callback: this.getPenalInterestRemarksCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getPenalInterestRemarksCallback = (response) => {
    this.setState({ errorList: response.errorList, penalInterestRemarksList: response.remarksList })
  }

  onCreateRemarksClick = (event) => {
    let objectCode = event.currentTarget.getAttribute('data-object-code')
    let objectId = event.currentTarget.getAttribute('data-object-id')
    this.setState({
      createMode: true,
      objectCode: objectCode,
      objectId: objectId
    })
  }

  onUpdateRemarksClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    let date = event.currentTarget.getAttribute('data-date')
    let selectedRemarks = event.currentTarget.getAttribute('data-remarks')
    let selectedRemarksId = event.currentTarget.getAttribute('data-remarks-id')

    this.setState({
      updateRemarksMode: true,
      objectId: objectId,
      createMode: false,
      selectedDate: date,
      selectedRemarks: selectedRemarks,
      selectedRemarksId: selectedRemarksId
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.state.loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanRemarks(this.props.match.params.loanId, 'penal_interest'))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
      this.getPenalInterestRemarks(context)
    }
    else {
      this.setState({
        loan: null,
        penalInterestRemarksList: null,
        errorList: null
      })
      this.getLoan(context)
      this.getPenalInterestRemarks(context)
    }
  }
}

export default withRouter(PenalInterestRemarksPageSF)
